import { SelectedCategoriesEnum as c } from "./selected-categories-enum.mjs";
const a = (e) => [
  {
    caption: e("special_characters.select_text"),
    id: c.Text
  },
  {
    caption: e("special_characters.select_currency"),
    id: c.Currency
  },
  {
    caption: e("special_characters.select_all"),
    id: c.All
  }
];
export {
  a as getCharactersCategoriesData
};
